<template>
  <div id="pdfContent" class="px-5 py-10 printpagebg">
    <div class="">
      <div>
        <div class="font-bold" style="font-size: 4mm">ACCESS ARM Pensions</div>

        <div class="flex">
          <div style="font-size: 3mm">
            <div>339 Cadastral Zone, Tarkwa Crescent,</div>
            <div>off Adetokunbo Ademola Crescent,</div>
            <div>Wuse 2,</div>
            <div>Abuja, Nigeria.</div>
          </div>

          <div class="separator"></div>

          <div class="ml-3 -mt-6" style="font-size: 3mm">
            <div class="ml-3 block">RC 6000930</div>
            <div class="ml-3 block mt-6">070000ACCESSARM</div>
            <div class="ml-3 block">02-094613333</div>
            <div class="ml-3 block mt-2">www.access-armpensions.com</div>
          </div>
        </div>

        <img
          :src="armlogo"
          alt=""
          class="w-[15%] bg-white p-[1px] rounded float-right -mt-36"
        />

        <div class="mt-10">{{ store.state.proof_of_fund_data.date }}</div>
        <div class="mt-2">The Managing Director</div>
        <div class="mt-2">
          {{ store.state.proof_of_fund_data.employer_name }}
        </div>
        <div class="mt-2">{{ store.state.proof_of_fund_data.address }}</div>

        <div>
          <div class="mt-10">Dear Sir/Ma,</div>

          <div class="font-extrabold mt-3">
            Evidence Of Remittance - {{ store.state.proof_of_fund_data.code }}
          </div>
          <div class="mt-3">
            We refer to your request on the above subject matter
          </div>

          <div class="mt-3">
            As requested, please find below the details of remittances received
            from
            <strong>{{ store.state.proof_of_fund_data.employer_name }}</strong>
            from
            <strong
              >{{ store.state.proof_of_fund_data.startDate }} to
              {{ store.state.proof_of_fund_data.endDate }}</strong
            >.
          </div>

          <div class="mt-3">
            We thank you for the opportunity to serve you and look forward to a
            continued mutually beneficial business relationship between
            <strong>{{ store.state.proof_of_fund_data.employer_name }}</strong
            >, and <strong>ACCESS ARM Pensions (PFA)</strong> Limited.
          </div>

          <div class="mt-3">Yours Faithfully,</div>
          <div>
            <img src="" alt="" />
          </div>
          <div class="mt-2">ACCESS ARM Pensions.</div>
          <div>
            <img
              :src="abiodunSiggy"
              alt=""
              class="w-[15%] bg-white p-[1px] rounded"
            />
          </div>
          <div class="mt-5">
            <div>
              <div>Abiodun Abijo</div>
              <div>Business Manager, South.</div>
            </div>
            <div style="float: right; margin-top: -134px">
              <img
                :src="tunjiSiggy"
                alt=""
                class="w-[78%] bg-white p-[1px] rounded"
              />
              <div>Tunji Olabode</div>
              <div>Business Manager, North.</div>
            </div>
          </div>

          <div style="font-size: 2mm; margin-top: 1.5rem">
            <strong style="color: #f58220">Head Office</strong>
            <div>Plot No. 339, Cadastral Zone A08, Takwa Crescent, o</div>
            <div>Adetokunbo Ademola Crescent, Wuse 2 – Abuja.</div>
            <div>
              <span style="color: #f58220; font-weight: 600">T:</span>
              02-094613333
            </div>
            <div>
              <span style="color: #f58220; font-weight: 600">E:</span>
              info@access-armpensions.com
            </div>
            <div>
              <span style="color: #f58220; font-weight: 600">W:</span>
              https://www.access-armpensions.com/
            </div>
          </div>
          <div style="font-size: 2mm">
            <div style="float: right; margin-top: -72px; margin-right: 13px">
              <div>
                <span style="font-weight: 600">Chairman:</span> Aigboje
                Aig-Imoukhuede
              </div>
              <div>
                <span style="font-weight: 600">MD/CEO:</span> Emenike Davies
                Uduanu
              </div>
              <div>
                <span style="font-weight: 600">ED:</span> Afolabi Folayan, Nuhu
                .A. Modibbo
              </div>
              <div>
                <span style="font-weight: 600">Non-ED:</span> Austin Opara, Okey
                Nwuke, Robert Imowo
              </div>
            </div>
          </div>

          <!-- <div
            class=""
            style="
              margin-top: 1rem;
              bottom: 0;
              left: 0;
              right: 0;
              font-size: 2mm;
            "
          >
           <div>
            <div>Head Office</div>
            <div>Lagos state and so on an so fault</div>
           </div>

           <div>
            Chairman: John George
            Chairman: Managing Director
           </div>
          </div> -->
        </div>

        <div class="mb-6" style="margin-top: 14rem">
          <div style="overflow-x: auto">
            <table
              style="
                width: 100%;
                font-size: 0.875rem;
                text-align: left;
                color: #4b5563;
                background-color: #ffffff;
                border-collapse: collapse;
              "
            >
              <thead
                style="
                  font-size: 0.75rem;
                  text-transform: uppercase;
                  background-color: #f9fafb;
                  color: #374151;
                "
              >
                <tr>
                  <th style="padding: 0.75rem; text-align: left">
                    Posting Date
                  </th>
                  <th style="padding: 0.75rem; text-align: left">
                    Description
                  </th>
                  <th style="padding: 0.75rem; text-align: left">
                    Original Amount
                  </th>
                  <th style="padding: 0.75rem; text-align: left">Period</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in store.state.proof_of_fund_data
                    .remittances?.remittance"
                  :key="index"
                >
                  <th
                    scope="row"
                    style="
                      padding: 1rem;
                      font-size: 11px;
                      font-weight: 500;
                      color: #111827;
                      white-space: nowrap;
                    "
                  >
                    {{ item?.date }}
                  </th>
                  <td style="padding: 1rem; font-size: 11px">
                    {{ item?.description }}
                  </td>
                  <td style="padding: 1rem; font-size: 11px">
                    N{{ item?.amount }}
                  </td>
                  <td style="padding: 1rem; font-size: 11px">
                    {{ item?.period_reference }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- <div class="footer first-page-footer fixed bottom-0">
          Mr. Abayomi Sanni (Chairman), Mr. Daniel Akujobi, Mr. Aliyu Yar’Adua,
          Mr. Sadiq Mohammed,Mr. Ingo Weber (German),Mrs. Yinka Edu (INED), Ms.
          Eme Essien Lore (INED),Mr. Wale Odutola (Managing Director),Mr. Osahon
          Ogiemudia (ED, Operations), Mr. Abisola Onigbogi (ED, Technical),Mrs.
          Abimbola Sulaiman (ED, Investment Management)
        </div> -->
      </div>
    </div>
  </div>

  <div>
    <div class="flex justify-center mt-6">
      <img :src="accessLogo" class="w-80 h-20" alt="arm-logo" id="showThis" />
    </div>
    <div
      class="flex flex-col items-center justify-center h-screen -mt-20"
      id="showThis"
    >
      <div class="mt-4 text-center">
        By default, you will be prompted to
        <strong class="underline">Save as PDF</strong> modal within few seconds,
        please do so.
      </div>
      <div class="mt-4 text-center">
        If you are not prompted to do so or it closed by accident, please click
        on the button below.
      </div>
      <div class="mt-4">
        <button
          @click.prevent="printPage()"
          class="bg-[#09518C] px-4 py-2 rounded-md text-white"
        >
          Click Here to save as PDF
        </button>
      </div>
    </div>
  </div>
  <!-- <div
    v-else
    class="flex flex-col items-center justify-center h-screen -mt-20"
    id="showThis"
  >
    <LoadingSpinner />
  </div> -->
</template>

<script setup>
import abiodunSiggy from "@/assets/signature-abiodun.png";
import tunjiSiggy from "@/assets/signature-tunji.png";
import accessLogo from "@/assets/AccessArmLogo.webp";
import { onBeforeUnmount, onMounted } from "vue";
import { useStore } from "vuex";

const store = useStore();

const printPage = () => {
  window.print();
};

const generateProofOfRemittance = () => {
  store
    .dispatch("proofOfFund", {
      start_date: store.state.global_payment_start_date,
      end_date: store.state.global_payment_end_date,
    })
    .then(() => {
      printPage();
    });
};

onMounted(() => {
  generateProofOfRemittance();
});

const footer = document.querySelector(".footer");

const handleBeforePrint = () => {
  footer.style.display = "block";
};

const handleAfterPrint = () => {
  footer.style.display = "none";
};

window.addEventListener("beforeprint", handleBeforePrint);
window.addEventListener("afterprint", handleAfterPrint);

onBeforeUnmount(() => {
  window.removeEventListener("beforeprint", handleBeforePrint);
  window.removeEventListener("afterprint", handleAfterPrint);
});
</script>

<style scoped>
.footer {
  display: none;
}

.first-page-footer {
  page-break-before: always;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  font-size: 2mm;
}

.printpagebg {
  min-height: 100vh;
  position: relative;
  display: none;
}

.printpagebg::after {
  content: "";
  /* background: url("../../../assets/pensions.png"); */
  opacity: 0.2;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
}

.separator {
  height: 120px;
  margin-left: 110px;
  width: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: #8dc63f;
  margin-top: -35px;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

@media print {
  .printpagebg {
    display: block;
  }

  #showThis {
    display: none;
  }

  body::before {
    content: "";
    opacity: 0.09;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: 9999;
    background-position: center;
    print-color-adjust: exact !important;
  }
  body {
    print-color-adjust: exact !important;
    position: relative;
    margin: 0;
  }
  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  .footer {
    display: block;
  }

  @page {
    margin: 20mm;
    @bottom-center {
      content: none;
    }
  }
}
</style>
